import { render, staticRenderFns } from "./ProductPriceDetails.vue?vue&type=template&id=af40eb36&"
import script from "./ProductPriceDetails.vue?vue&type=script&lang=js&"
export * from "./ProductPriceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports